import { staffTeamLoadSchema } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
export function createStaffTeamLoadApi(options) {
    const send = createMemoryTransport(options);
    return {
        teamLoad: (callOptions) => send({
            method: "GET",
            path: "/staff/team/load",
            schema: staffTeamLoadSchema,
            signal: callOptions?.signal,
        }),
    };
}
